import { render, staticRenderFns } from "./FeesCreate.vue?vue&type=template&id=5b46d299"
import script from "./FeesCreate.vue?vue&type=script&lang=js"
export * from "./FeesCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports